import { defineStore } from 'pinia'
import useValidate from '@/shared/lib/validate'
import { ref, watchEffect } from 'vue'
import { cloneDeep } from 'lodash'
import type { ScheduleEditTypes } from './type'
import { useLoadShortSchedule } from '@/entities/Schedule'

export const useModel = defineStore('schedule_edit', () => {
  const { required } = useValidate()

  const editId = ref<number>(0)
  const openForm = ref(false)
  const editType = ref<ScheduleEditTypes>('rename')

  /* Данные формы */
  const fields: {
    id: number
    group_object_list_id: number
    old_group_object_list_id: number
    name: string
    description: ''
  } = {
    id: 0,
    group_object_list_id: 1,
    old_group_object_list_id: 1,
    name: '',
    description: '',
  }

  const data = ref(cloneDeep(fields))

  /* Правила валидации */
  const rules = {
    name: [(value: string) => required(value)],
  }

  const loadData = () => {
    const result = useLoadShortSchedule(editId)

    watchEffect(() => {
      if (result.data.value) {
        const res = result.data.value.data

        data.value = {
          id: res.id,
          group_object_list_id: res.group_object_list_id,
          old_group_object_list_id: res.group_object_list_id,
          name: res.name,
          description: res.description,
        }
      }
    })

    return result
  }

  /**
   * Функция очистки формы после закрытия
   */
  const closeForm = () => {
    openForm.value = false
    data.value = cloneDeep(fields)
    editId.value = 0
  }

  return {
    data,
    rules,
    openForm,
    editType,
    editId,

    closeForm,
    loadData,
  }
})
